export default "__VITE_ASSET__Bo5F7FlP__"